<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-toc" epub:type="toc" id="table-of-contents" role="doc-toc">
<div class="toc-heading"><h1 class="toc-title">Contents</h1></div>
<div class="toc-contents text">
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/todayiremember"><span class="item-title-text">Today I Remember</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/ilgrancavallo"><span class="item-title-text">Il Gran Cavallo</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/unrefined" title="Link target outside of Sample"><span class="item-title-text">Unrefined</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/fatherdaughterouting" title="Link target outside of Sample"><span class="item-title-text">Father-Daughter Outing</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/todayiampaul" title="Link target outside of Sample"><span class="item-title-text">Today I Am Paul</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/scramble" title="Link target outside of Sample"><span class="item-title-text">Scramble</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/thevampiresnewclothes" title="Link target outside of Sample"><span class="item-title-text">The Vampire’s New Clothes</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/viewfromahill" title="Link target outside of Sample"><span class="item-title-text">View from a Hill</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/themotheranthony" title="Link target outside of Sample"><span class="item-title-text">The Mother Anthony</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/bookmarked" title="Link target outside of Sample"><span class="item-title-text">Bookmarked</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/onelastchoreforgrandpa" title="Link target outside of Sample"><span class="item-title-text">One Last Chore for Grandpa</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-about-author has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/abouttheauthor" title="Link target outside of Sample"><span class="item-title-text">About the Author</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-also-by has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/ifyouliked" title="Link target outside of Sample"><span class="item-title-text">If You Liked …</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-also-by has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/otherwordfirepresstitlesbymartinlshoemaker" title="Link target outside of Sample"><span class="item-title-text">Other WordFire Press Titles by Martin L. Shoemaker</span></span></p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6bbe8cfd